import { render, staticRenderFns } from "./ArticleProductSlider.vue?vue&type=template&id=e390b0e8&"
import script from "./ArticleProductSlider.vue?vue&type=script&lang=js&"
export * from "./ArticleProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./ArticleProductSlider.vue?vue&type=style&index=0&id=e390b0e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports